import { render, staticRenderFns } from "./DashboardChecklists.vue?vue&type=template&id=0e7c80fe"
import script from "./DashboardChecklists.vue?vue&type=script&lang=ts"
export * from "./DashboardChecklists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports